import axios from "axios";

const COUNSELLOR_API_BASE_URL = "http://103.186.133.119:5177/api/v1";

export const initiateIVRCall = async (doctor_id, customer_id) => {
    try {
        const response = await axios.post(`${COUNSELLOR_API_BASE_URL}/ivr/call`, {
            doctor_id,
            customer_id,
        });

      
        return response.data;
    } catch (error) {
        console.error('Error initiating IVR call:', error.response || error.message);
        throw error;
    }
};